import { API } from 'app/api';

export function getWorkspaceSettingsApi(data) {
  return API.post('/api/page/workspaceSettings', data);
}

export function setWorkspaceSettingsApi(data) {
  return API.post('/api/discussiongroups/setWorkspaceSettings', data);
}